export const SIDES = Object.freeze({
    FRONT: 'front',
    BACK: 'back'
});
